import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";

interface GeneralContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const GeneralContactDialog = ({ open, onOpenChange }: GeneralContactDialogProps) => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    
    try {
      // Note: contact_submissions table doesn't exist, would need to be created first
      console.log("Would submit contact form:", {
        first_name: formData.get('firstName') as string,
        last_name: formData.get('lastName') as string,
        email: formData.get('email') as string,
        message: formData.get('message') as string,
        type: 'general'
      });
      // const { error } = await supabase
      //   .from('contact_submissions')
      //   .insert({
      //     first_name: formData.get('firstName') as string,
      //     last_name: formData.get('lastName') as string,
      //     email: formData.get('email') as string,
      //     message: formData.get('message') as string,
      //     type: 'general'
      //   });
      // if (error) throw error;

      toast({
        title: "Message sent!",
        description: "We'll get back to you as soon as possible.",
      });

      form.reset();
      onOpenChange(false);
    } catch (error) {
      console.error('Error submitting form:', error);
      toast({
        title: "Error",
        description: "There was a problem sending your message. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] bg-white border shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold text-center">
            General Inquiry
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                First Name
              </label>
              <Input 
                id="firstName" 
                name="firstName" 
                required 
                className="bg-white border-gray-300"
                placeholder="John"
              />
            </div>
            <div>
              <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                Last Name
              </label>
              <Input 
                id="lastName" 
                name="lastName" 
                required 
                className="bg-white border-gray-300"
                placeholder="Doe"
              />
            </div>
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <Input 
              id="email" 
              name="email" 
              type="email" 
              required 
              className="bg-white border-gray-300"
              placeholder="john@example.com"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
              Message
            </label>
            <Textarea 
              id="message" 
              name="message" 
              required 
              className="bg-white border-gray-300 min-h-[120px] resize-none"
              placeholder="How can we help you?"
            />
          </div>
          
          <Button 
            type="submit" 
            className="w-full bg-primary hover:bg-primary/90 text-white"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};